<app-content-header [contentHeader]="contentHeader"></app-content-header>

<div class="card">
    <div class="row p-50">
        <div class="col-xl-3 col-md-6 col-sm-12">
            <ng-select [items]="companies" bindValue="id" bindLabel="companyName" placeholder="Firma Seç"
                [(ngModel)]="selectedCompanyId" (change)="onCompanySelect($event)"></ng-select>
        </div>
        <div class="col-xl-2 col-md-6 col-sm-12">
            <select class="form-control" [(ngModel)]="selectedAkradetionOgranizationId"
                placeholder="Akraditasyon Kurumu Seç" (change)="onAkreditonOgranzitonChange($event)">
                <option *ngFor="let item of akradetionOrganization" [value]="item.id">{{item.name}}</option>
            </select>
        </div>
        <div class="col-xl-2 col-md-6 col-sm-12">
            <select class="form-control" [(ngModel)]="selectedStatusId" (change)="onStatus($event)"
                placeholder="Durumu">
                <option *ngFor="let item of calibrationStatusOptions" [value]="item.value">{{item.text}}</option>
            </select>
        </div>
        <div class="col-md-3 col-sm-12">
            <div class="input-group">
                <input name="datepicker" class="form-control" ngbDatepicker #datepicker="ngbDatepicker"
                    placeholder="yyyy-mm-dd - yyyy-mm-dd" [value]="displayDateRange()" (click)="datepicker.toggle()"
                    (dateSelect)="onDateSelection($event)" [autoClose]="'outside'" [dayTemplate]="rangeSelectionDP"
                    outsideDays="hidden" [startDate]="fromDate!" />
                <ng-template #rangeSelectionDP let-date let-focused="focused">
                    <span class="custom-day" [class.focused]="focused" [class.range]="isRange(date)"
                        [class.faded]="isHovered(date) || isInside(date)" (mouseenter)="hoveredDate = date"
                        (mouseleave)="hoveredDate = null">
                        {{ date.day }}
                    </span>
                </ng-template>
                <div class="input-group-append">
                    <button class="btn btn-outline-secondary feather icon-calendar" (click)="datepicker.toggle()"
                        type="button"></button>
                </div>
            </div>
        </div>
        <div class="col-xl-1 col-md-1 col-sm-1">
            <button type="button" class="btn btn-icon btn-flat-danger" rippleEffect (click)="resetFilter()">
                <span [data-feather]="'trash'"></span></button>
        </div>
        <div class="justify-content-end">
            <select class="form-control" [(ngModel)]="basicSelectedOption" (ngModelChange)="onOptionChange()">
                <option value="5">5</option>
                <option value="10">10</option>
                <option value="15">15</option>
                <option value="50">50</option>
            </select>
        </div>
    </div>
    <ngx-datatable [rows]="rows" [rowHeight]="50" class="bootstrap core-bootstrap" style="cursor: pointer;" [messages]="{ 
        emptyMessage: 'Veri Yok',
        totalMessage: 'Toplam', 
        selectedMessage: 'Seçili'
      }" [limit]="selectedSize" [columnMode]="ColumnMode.force" [headerHeight]="50" [footerHeight]="50"
        [scrollbarH]="true">

        <ngx-datatable-column name="Kal No" prop="calibrationNo" [width]="50"></ngx-datatable-column>
        <ngx-datatable-column name="Cihaz Adı" prop="deviceName" [width]="150"></ngx-datatable-column>
        <ngx-datatable-column name="Firma Adı" prop="companyName" [width]="200"></ngx-datatable-column>
        <ngx-datatable-column name="Kalibrasyon Tarihi" [width]="75">
            <ng-template let-row="row" ngx-datatable-cell-template>
                {{row.calibrationDate | date:'dd.MM.yyyy'}}
            </ng-template>
        </ngx-datatable-column>

        <ngx-datatable-column name="Akradite Kurumu" [width]="75">
            <ng-template let-row="row" ngx-datatable-cell-template>
                {{ calibrationAkradetionOrganization(row.accreditationOrganization)}}
            </ng-template>
        </ngx-datatable-column>

        <ngx-datatable-column name="Kal. Yapan Kişi" [width]="150">
            <ng-template let-row="row" ngx-datatable-cell-template>
                {{row.name}} {{row.lastName}}
            </ng-template>
        </ngx-datatable-column>

        <ngx-datatable-column name="Sert. Basıldı mı?" [width]=50>
            <ng-template let-row="row" ngx-datatable-cell-template>
                <div class="badge" [ngClass]="row.certificateMissingOrStatusFalse ? 'badge-success':'badge-danger'">
                    {{row.certificateMissingOrStatusFalse ? 'Basıldı' : 'Basılmadı' }}</div>
            </ng-template>
        </ngx-datatable-column>

        <ngx-datatable-column name="Durum" [width]="75">
            <ng-template let-row="row" ngx-datatable-cell-template>
                <select [ngClass]="calibrationStatusMapping[row.status]?.style"
                    (change)="updateStatus(row, $event.target.value)">
                    <option *ngFor="let option of calibrationStatusOptions" [value]="option.value"
                        [ngClass]="calibrationStatusMapping[option.value]?.style"
                        [selected]="row.status === option.value">
                        {{ option.text }}
                    </option>
                </select>
            </ng-template>
        </ngx-datatable-column>


        <ngx-datatable-column name="#" [sortable]="false" [width]="50">
            <ng-template let-row="row" ngx-datatable-cell-template>
                <button type="button" class="btn btn-icon btn-flat-warning" rippleEffect
                    (click)="showUpdateCalibration(row.id)">
                    <span [data-feather]="'edit'"></span></button>

                <button type="button" class="btn btn-icon btn-flat-info" rippleEffect *ngIf="!row.certificateMissingOrStatusFalse"
                    (click)="showCreateCertificate(row.id)">
                    <span [data-feather]="'file'"></span></button>
            </ng-template>
        </ngx-datatable-column>

        <ngx-datatable-footer>
            <ng-template ngx-datatable-footer-template>
                <div class="datatable-footer-inner">
                    <div class="page-count">
                        Toplam Veri {{ totalCount }}
                    </div>
                    <ngb-pagination [collectionSize]="(totalCount / basicSelectedOption) * 10" [(page)]="pageBasic"
                        (pageChange)="onPageChange($event)" [maxSize]="5">
                        <ng-template ngbPaginationPrevious>
                            <span [data-feather]="'chevron-left'" [size]="18" [class]="'font-weight-bolder'"></span>
                        </ng-template>
                        <ng-template ngbPaginationNext>
                            <span [data-feather]="'chevron-right'" [size]="18" [class]="'font-weight-bolder'"></span>
                        </ng-template>
                    </ngb-pagination>
                </div>
            </ng-template>
        </ngx-datatable-footer>
    </ngx-datatable>
</div>